module.exports = __webpack_public_path__ + "img/44.b8fa3a71.png";